module.exports = __webpack_public_path__ + "static/img/login_logo.d0ce4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/login_logo.png
// module id = 76jT
// module chunks = 12